import React, { useEffect, useState } from "react";

export default function InstallPrompt() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstall, setShowInstall] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowInstall(true);
        };

        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        console.log("User response:", outcome);
        setDeferredPrompt(null);
        setShowInstall(false);
    };

    if (!showInstall) return null;

    return (
        <div style={styles.prompt}>
            <p>Install aplikasi ini ke layar utama?</p>
            <button style={styles.button} onClick={handleInstallClick}>
                Install
            </button>
            <button style={styles.button} onClick={() => setShowInstall(false)}>
                Nanti
            </button>
        </div>
    );
}

const styles = {
    prompt: {
        position: "fixed",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        background: "#fff",
        padding: "12px 20px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        zIndex: 9999,
        textAlign: "center"
    },
    button: {
        margin: "0 8px",
        padding: "8px 14px",
        background: "#0d6efd",
        border: "none",
        color: "#fff",
        borderRadius: "6px",
        cursor: "pointer"
    }
};
